import logoHeader from '../../assets/img/logo.svg';

const MainLoader = () => (
  <div className="pulse-wrapper">
    <div className="pulse">
      <div className="logo">
        <div className="logo-img">
          <img src={logoHeader} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default MainLoader;
